import { getCurrentTerms } from "../projectTypeUtils";

const TERMS = getCurrentTerms()

export const columns = [
  {
    "key": 1,
    "value": "part_name",
    "hidden": false
  },
  {
    "key": 2,
    "value": "part_description",
    "hidden": false
  },
  {
    "key": 3,
    "value": "project_quantity",
    "hidden": false
  },
  {
    "key": 4,
    "value": "construction_spares",
    "hidden": true
  },
  {
    "key": 5,
    "value": "addl_qty_incl_o&m_spares",
    "hidden": true
  },
  {
    "key": 6,
    "value": "total_quantity",
    "hidden": true
  },
  {
    "key": 7,
    "value": "on-site_qty",
    "hidden": false
  },
  {
    "key": 8,
    "value": "balance_qty",
    "hidden": false
  },
  {
    "key": 9,
    "value": "distributed",
    "children": [
      "percentage",
      "qty"
    ],
    "hidden": false
  },
  {
    "key": 10,
    "value": "installed",
    "children": [
      "percentage",
      "qty"
    ],
    "hidden": false
  }
]

export const NextrackerLayoutOptions = [
  { value: 'pier', label: 'Layout' },
  { value: 'part number', label: 'Pier Map' },
  { value: 'torque tube', label: 'TT Map' },
  { value: 'bha', label: 'BHA & SG Map' }
];
export const ZimmermanLayoutOptions = [
  { value: 'pier', label: 'Layout' },
  { value: 'c rails', label: 'C Rails Map' },
  { value: 'v tube', label: 'V Tube Map' },
];


export const ITCCOLUMNS = [
  {
    "key": 1,
    "value": "block",
    "hidden": false
  },
  {
    "key": 2,
    "value": TERMS.SECTION_HEADER,
    "hidden": false
  },
  {
    "key": 3,
    "value": TERMS.ROW_HEADER,
    "hidden": false
  },
  {
    "key": 4,
    "value": "punchlist_category",
    "hidden": false
  },
  {
    "key": 5,
    "value": "scope",
    "hidden": false
  },
  {
    "key": 6,
    "value": "status",
    "hidden": false
  }
];

export const ITRCOLUMNS = [
  {
    "key": 1,
    "value": "itr_reference_number",
    "hidden": false
  },
  {
    "key": 2,
    "value": "punchlist_category",
    "hidden": false
  },
  {
    "key": 3,
    "value": "scope",
    "hidden": false
  },
  {
    "key": 4,
    "value": "status",
    "hidden": false
  }
];


export const temp = [
  {
    "key": 1,
    "value": "date",
    "display_name": "Date",
    "type" : "date",
    "format": "DD-MM-YYYY AM"
  },
  {
    "key": 2,
    "value": "pilling",
    "display_name": "Pilling",
    "type" : "int",
    "format": "Number"
  },
  {
    "key": 3,
    "value": "pilling",
    "display_name": "Pilling",
    "type" : "int",
    "format": "Number"
  },
  {
    "key": 4,
    "value": "linked_part",
    "display_name": "Linked Part",
    "type" : "int",
    "format": "Number"
  },
  {
    "key": 5,
    "value": "total_quantity",
    "display_name": "Total Quantity",
    "type" : "int",
    "format": "Number"
  },
  {
    "key": 6,
    "value": "descrition",
    "display_name": "Description",
    "type" : "text",
    "format": "string"
  }
]